<template>
    <div>
      <div class="alert alert-warning alert-dismissible fade show" role="alert" v-show="alert">
              <span class="alert-icon"><i class="fas fa-exclamation-circle"></i></span>
              <span class="alert-text"><strong>Ups! </strong>{{mensaje}}!</span>
              <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
        <div class="row justify-content-center">
          
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0 mt-7" >
            <div class="card-header bg-transparent pb-5">
              <h1 class="text-center">INGRESO ROMANA V2</h1>
            </div>
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Proporcione Sus Credenciales</small>
              </div>
              <form role="form">
                <div class="form-group mb-3">
                  <div class="input-group input-group-merge input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                    </div>
                    <input class="form-control" v-model="usuario" placeholder="Usuario (XXXXXXXX-X)" type="text">
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group input-group-merge input-group-alternative">
                    <div class="input-group-prepend" @mouseover="cambiar_tipo" @mouseleave="cambiar_tipo_2">
                      <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                    </div>
                    <input class="form-control" v-model="clave" placeholder="Clave" :type="tipo" @keyup.enter="ingresar">
                  </div>
                </div>
                <div class="custom-control custom-control-alternative custom-checkbox">
                  <input class="custom-control-input" id=" customCheckLogin" type="checkbox" v-model="recordar">
                  <label class="custom-control-label" for=" customCheckLogin">
                    <span class="text-muted">Recordar Credenciales</span>
                  </label>
                </div>
                <div class="text-center">
                  <button type="button" class="btn btn-primary my-4" @click="ingresar">Ingresar</button>
                </div>
              </form>
            </div>
          </div>
          <!-- <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light"><small>Forgot password?</small></a>
            </div>
            <div class="col-6 text-right">
              <a href="#" class="text-light"><small>Create new account</small></a>
            </div>
          </div> -->
        </div>
      </div>

      <!-- <pre>
            Autenticado: {{autenticado}}
        </pre>
        <pre>
            token: {{token}}
        </pre>
        <pre>
            cabecera_json: {{cabeceras_json}}
        </pre>
        <pre>
            menus: {{menus}}
        </pre> -->
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
    data:()=>({
        usuario:'',
        clave:'',
        mensaje:'',
        alert:false,
        recordar:true,
        tipo:'password'
    }),
    mounted(){
      this.usuario = this.username;
      this.clave = this.password;
      this.recordar = false;
    },
    methods: {
        async ingresar(){
            await this.axios.post(`${this.api}/login`,{user:this.usuario,password:this.clave}).then((res) => {
                ////console.log(res.data)
                if(res.data.autenticado){
                  this.iniciarSesion(res.data);
                  if(this.recordar){
                    this.cambiar_credenciales({username:this.usuario,password:this.clave});
                  }
                  
                  this.$router.push({path:'/inicio'});

                }
                else{
                  this.mensaje = res.data.message;
                  this.alert = true;
                }
                
            }).catch((e)=>{
                //console.log(e);
            })
        },

        cambiar_tipo(){
            this.tipo = 'text';
        },

        cambiar_tipo_2(){
          this.tipo = 'password';
        },
        ...mapActions(['iniciarSesion','cambiar_credenciales'])
    },
    computed:{
        ...mapState({
          autenticado:state => state.autenticado,
          token:state => state.token,
          cabeceras_json:state => state.cabeceras_json,
          menus:state => state.menus,
          api:state => state.api,
          user:state => state.user,
          password:state => state.password
        })
    }
}
</script>